
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

import vSelect from "vue-select"

import { get } from "lodash"

import { getMapStyle } from "@/scripts/mapStyle"
import api from "@/services/api"

import {
	getEnhancedMapping,
	IEnhancedMapping,
	IMap,
	IHeatMap
} from "@sureview/v2-mapping"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class HeatMap extends Vue {
	$refs!: {
		mappingContainer: HTMLElement,
	}

	@Prop()
	resultGroups: any;

	@Prop()
	columns: any;

	@Prop()
	options!: any;

	@State darkMode!: boolean;

	public mapKey: string = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";

	public enhancedMapping: IEnhancedMapping | null = null;
	public map: IMap | null = null;
	public heatMap: IHeatMap | null = null;

	private markerColumn: any = null;

	private get columnKey () {
		return this.options ? this.options.markerColumn : null
	}

	private get markerColumns () {
		if (!this.columns) return []
		return this.columns.filter((c: any) => c.dataType === "map-marker")
	}

	private get markerData () {
		if (!this.markerColumn) return []

		return this.resultGroups.map((group: any) =>
			group.results.map((row: any) =>
				get(row, this.markerColumn.dynamicField ? this.markerColumn.key + ".value" : this.markerColumn.key))
				.filter((v: any) => !!v)
				.reduce((merged: any, items: any) => {
					return merged.concat(items)
				}, []))
			.reduce((merged: any, items: any) => {
				return merged.concat(items)
			}, [])
	}

	async mounted () {
		if (this.markerColumns.length > 0) {
			if (this.columnKey) {
				this.markerColumn = this.markerColumns.find((c: any) => c.key === this.columnKey)
			}

			if (!this.markerColumn) {
				this.markerColumn = this.markerColumns[0]
			}
		}

		this.enhancedMapping = await getEnhancedMapping("google", this.mapKey)

		this.map = this.enhancedMapping!.createMultipleMap(
			this.$refs.mappingContainer,
			{ lat: 0, lng: 0 },
			0,
			false,
			"roadmap",
			getMapStyle(this.darkMode, "roadmap", false)
		)

		this.updateData()
	}

	beforeDestroy () {
		if (this.enhancedMapping && this.map) {
			this.enhancedMapping!.releaseMultipleMap(this.map)
		}
		if (this.heatMap) {
			this.heatMap.remove()
		}
	}

	updateData () {
		if (this.heatMap) {
			this.heatMap.remove()
		}

		if (!this.map) return

		this.heatMap = this.enhancedMapping!.createHeatmap(this.map!, this.markerData)
		this.map!.mapBounds = this.heatMap.bounds
	}
}
